export const NAV = {
  logoLink: "nav-logo-link",
  linkHome: "nav-link-home",
  linkAbout: "nav-link-about",
  linkIA: "nav-link-ia",
  linkPH: "nav-link-ph",
  linkPortfolio: "nav-link-portfolio",
  linkContact: "nav-link-contact",
  linkDeposit: "nav-link-deposit",
  cta: "nav-cta-book",
  menuToggle: "nav-menu-toggle",
};

export const HERO = {
  ctaBook: "hero-cta-book",
  ctaWork: "hero-cta-work",
};

export const HOME = {
  brandCardIA: "home-brand-card-ia",
  brandCardPH: "home-brand-card-ph",
  statsStrip: "home-stats-strip",
  testimonialsCarousel: "home-testimonials-carousel",
  testimonialPrev: "home-testimonial-prev",
  testimonialNext: "home-testimonial-next",
};

export const PORTFOLIO = {
  filter: (id) => `portfolio-filter-${id}`,
  item: (id) => `portfolio-item-${id}`,
  lightboxClose: "portfolio-lightbox-close",
  lightboxNext: "portfolio-lightbox-next",
  lightboxPrev: "portfolio-lightbox-prev",
};

export const CONSULT = {
  form: "consult-form",
  toggleIA: "consult-toggle-ia",
  togglePH: "consult-toggle-ph",
  name: "consult-input-name",
  email: "consult-input-email",
  phone: "consult-input-phone",
  whatsappOK: "consult-checkbox-whatsapp",
  eventType: "consult-select-event-type",
  date: "consult-date-button",
  dateTBD: "consult-checkbox-date-tbd",
  guestCount: "consult-select-guest-count",
  venue: "consult-input-venue",
  cuisine: (v) => `consult-cuisine-${v}`,
  dietary: (v) => `consult-dietary-${v}`,
  service: (v) => `consult-service-${v}`,
  budget: "consult-select-budget",
  discovery: "consult-select-discovery",
  notes: "consult-textarea-notes",
  honeypot: "consult-honeypot",
  submit: "consult-submit-button",
  successCard: "consult-success-card",
};

export const FOOTER = {
  root: "footer-root",
  emailLink: "footer-email-link",
  phoneLink: "footer-phone-link",
  instagram: "footer-instagram",
  facebook: "footer-facebook",
  depositLink: "footer-deposit-link",
};

export const WA = {
  float: "whatsapp-float-button",
};

export const DEPOSIT = {
  form: "deposit-form",
  name: "deposit-input-name",
  email: "deposit-input-email",
  phone: "deposit-input-phone",
  proposalRef: "deposit-input-proposal-ref",
  amount: "deposit-input-amount",
  note: "deposit-input-note",
  submit: "deposit-submit-button",
  successCard: "deposit-success-card",
  amount25: "deposit-preset-25",
  amount50: "deposit-preset-50",
  amount100: "deposit-preset-100",
  backHome: "deposit-back-home",
};

// Legacy — kept so old imports don't break
export const INQUIRY = {
  form: "consult-form",
  name: "consult-input-name",
  email: "consult-input-email",
  phone: "consult-input-phone",
  eventType: "consult-select-event-type",
  eventDateButton: "consult-date-button",
  guestCount: "consult-select-guest-count",
  budget: "consult-select-budget",
  message: "consult-textarea-notes",
  honeypot: "consult-honeypot",
  submit: "consult-submit-button",
  successCard: "consult-success-card",
};
